/**
 * @desc 保存新闻
 */
import { NewsEntity, NewsForm } from '@eastcoal/api/content/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateNewsParameter = NewsForm

const method = 'POST'
const url = '/content/operation/news'

export const createNewsApi = (
  data?: CreateNewsParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<NewsEntity>({
    method,
    url,
    data,
    ...config
  })
}

createNewsApi.method = method
createNewsApi.url = url
